<template>
  <div id="app">
    <div class="content-page-main container is-fluid">
      <app-navbar></app-navbar>
      <router-view class="section box is-fullheight"/>
    </div>
  </div>
</template>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

</style>
<script>
import AppNavbar from "./components/AppNavbar";

export default {
  components: {
    AppNavbar
  }
}
</script>

<style scoped>
.content-page-main {
  margin-top: 1rem !important;
}
</style>
